import React from 'react';
import {
  GridAddToListButton,
  GridColumnMenu,
  GridExportMenu,
} from './components';

const NewTableControls = ({
  columns,
  columnVisibilityModel,
  setColumnVisibilityModel,
  onExport,
  isExporting,
  showExportButton = true,
  isExportButtonDisabled = false,
}) => {
  return (
    <div className="flex items-center justify-between w-full gap-2">
      <GridAddToListButton />
      <div className="flex-1">
        <div className="flex items-center justify-end whitespace-nowrap gap-2">
          {showExportButton && (
            <GridExportMenu
              onExport={onExport}
              isExporting={isExporting}
              disabled={isExportButtonDisabled}
            />
          )}
          <GridColumnMenu
            columns={columns}
            columnVisibilityModel={columnVisibilityModel}
            setColumnVisibilityModel={setColumnVisibilityModel}
          />
        </div>
      </div>
    </div>
  );
};

export default NewTableControls;
